// Type for YAML-based job post services
export interface YamlJobPostService {
  id: string;
  name: string;
  images?: any[];
  url?: string;
}

export default class JobPostService {
  id: string;
  name: string;
  images: any[];
  url: string | null;

  constructor(service: YamlJobPostService) {
    this.id = service.id;
    this.name = service.name!;
    this.images = (service.images as any) || [];
    this.url = service.url ?? null;
  }
}
